import React, { useEffect, useState } from "react";
import axios from "axios";
import baseUrl from "../../../baseUrl";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../Spinner/Spinner";

const AddStudents = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const { id } = useParams();

  const [showModal, setShowModal] = useState(false);

  const [registrationNumber, setRegistrationNumber] = useState("");
  const [studentName, setStudentName] = useState("");
  const [studentEmail, setStudentEmail] = useState("");
  const [studentDOB, setStudentDOB] = useState("");
  const [studentAddress, setStudentAddress] = useState("");
  const [studentContact, setStudentContact] = useState("");
  const [password, setPassword] = useState("");
  const [studentPicture, setStudentPicture] = useState("");
  const [studentParentName, setStudentParentNAme] = useState("");
  const [studentParentContact, setStudentParentContact] = useState("");
  const [studentParentRelation, setStudentParentRelation] = useState("");
  const [batchName, setBatchName] = useState(id);



  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

 

  // handle submit for create exam
  const handleSubmit = (e) => {
    const formData = new FormData();
    formData.append("registrationNumber", registrationNumber);
    formData.append("studentName", studentName);
    formData.append("batchName", batchName);
    formData.append("studentEmail", studentEmail);
    formData.append("studentDOB", studentDOB);
    formData.append("studentAddress", studentAddress);
    formData.append("studentPhoneNumber", studentContact);
    formData.append("studentPicture", studentPicture);
    formData.append("password", password);
    formData.append("studentParentName", studentParentName);
    formData.append("studentParentContact", studentParentContact);
    formData.append("studentParentRelation", studentParentRelation);

    e.preventDefault();
    setLoading(true);
    axios
      .post(`${baseUrl}/admin/add-students`, formData, {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.success === true) {
          toast.success(res.data.message);
          navigate("/admin/batch-details/" + id);

          window.location.reload();
        } else {
          toast.error(res.data.message);
          navigate("/admin/batch-details/" + id);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });

    setShowModal(false);
  };

  return (
    <>
      {loading && <Spinner />}
      <button
        className="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
        type="button"
        onClick={() => setShowModal(true)}
      >
        <i className="fa-solid fa-plus mr-1"></i> Add Students
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex flex-col items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold">Add Students</h3>

                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>

                {/*body*/}

                <form onSubmit={handleSubmit}>
                  <div>
                    <div className="mb-1 ml-10 md:flex">
                      <div className="mb-4 md:mr-2 md:mb-0 ml-2">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Register Number
                        </label>
                        <input
                          className="w-full px-3 py-2 text-sm leading-tight focus:outline-green-500 border-green-300 text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="text"
                          name="registrationNumber"
                          value={registrationNumber}
                          onChange={(e) =>
                            setRegistrationNumber(e.target.value)
                          }
                          required
                        />
                      </div>
                      <div className="mb-4 md:mr-2 md:mb-0 ml-2">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Batch&nbsp;Name
                        </label>
                        <input
                          className="w-full px-3 py-2 text-sm leading-tight focus:outline-green-500 border-green-300 text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="text"
                          name="batchName"
                          value={batchName}
                          onChange={(e) => setBatchName(e.target.value)}
                          disabled
                          required
                        />
                      </div>
                      <div className="mb-4 md:mr-2 md:mb-0 ml-2">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Student Name
                        </label>
                        <input
                          className="w-full px-3 py-2 text-sm leading-tight focus:outline-green-500 border-green-300 text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="text"
                          name="studentName"
                          value={studentName}
                          onChange={(e) => setStudentName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-4 md:mr-2 md:mb-0">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Student Email
                        </label>
                        <input
                          className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="email"
                          name="studentEmail"
                          value={studentEmail}
                          onChange={(e) => setStudentEmail(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="mb-1 ml-10 md:flex">
                      <div className="mb-1 md:mr-2 md:mb-0">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Student DOB
                        </label>
                        <input
                          className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="date"
                          name="studentDOB"
                          value={studentDOB}
                          onChange={(e) => setStudentDOB(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-1 md:mr-2 md:mb-0">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Student Address
                        </label>
                        <input
                          className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="text"
                          name="studentAddress"
                          value={studentAddress}
                          onChange={(e) => setStudentAddress(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-1 md:mr-2 md:mb-0">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Student Contact
                        </label>
                        <input
                          className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="number"
                          name="studentContact"
                          value={studentContact}
                          onChange={(e) => setStudentContact(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-4 md:mr-2 md:mb-0">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Student Password
                        </label>
                        <input
                          className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="text"
                          name="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className="mb-1 ml-10 md:flex">
                      <div className="mb-1 md:mr-2 md:mb-0">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Student Picture
                        </label>
                        <input
                          className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="file"
                          accept="image/*"
                          name="studentPicture"
                          onChange={(e) => setStudentPicture(e.target.files[0])}
                          required
                        />
                      </div>
                      <div className="mb-1 md:mr-2 md:mb-0">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Parent's Name
                        </label>
                        <input
                          className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="text"
                          name="studentParentName"
                          value={studentParentName}
                          onChange={(e) => setStudentParentNAme(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-1 md:mr-2 md:mb-0">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Parent's Contact
                        </label>
                        <input
                          className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="number"
                          name="studentParentContact"
                          value={studentParentContact}
                          onChange={(e) =>
                            setStudentParentContact(e.target.value)
                          }
                          required
                        />
                      </div>
                      <div className="mb-4 md:mr-2 md:mb-0">
                        <label className="block mb-2 text-sm font-bold text-gray-700">
                          Student's Relation
                        </label>
                        <input
                          className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                          type="text"
                          name="studentParentRelation"
                          value={studentParentRelation}
                          onChange={(e) =>
                            setStudentParentRelation(e.target.value)
                          }
                          required
                        />
                      </div>
                    </div>
                  </div>

                  {/*body*/}
                  {/*footer*/}
                  <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                    <button
                      className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default AddStudents;
